import { useEffect, useState } from 'react';
import styles from './Stage.module.scss';
import classNames from 'classnames';
import { formatDate } from '../../../../functions/formatDate';
import ContentContainer from '../../../universal_components/ContentContainer/ContentContainer';

const Stage = ({ stages }) => {
  const [activeStageNum, setActiveStageNum] = useState(1);
  const [activeStage, setActiveStage] = useState();

  useEffect(() => {
    setActiveStage(stages.find((stage) => stage.number == activeStageNum));
  }, [activeStageNum]);

  if (stages.length === 0) return false;

  return (
    <div id="stages" className={styles.section}>
      <ContentContainer>
        <div className={styles.wrapper}>
          <p className={styles.title}>ЭТАПЫ</p>
          <div className={styles.stages}>
            {stages.map((stage, id) => {
              return (
                <div key={id} onClick={() => setActiveStageNum(stage.number)} className={styles.numberWrapper}>
                  <div key={stage.number} className={styles.stage}>
                    <div
                      className={classNames(styles.num, {
                        [styles.numActive]: activeStageNum === stage.number,
                      })}>
                      {stage.number}
                    </div>
                    <p className={styles.start}>{formatDate(stage.start_date)}</p>
                    <p className={styles.end}>{formatDate(stage.end_date)}</p>
                  </div>
                </div>
              );
            })}
          </div>
          {activeStage && (
            <div className={styles.desc}>
              <div className={styles.startDate}>
                <p>{formatDate(activeStage.substage[0].start_date)}</p>
              </div>

              {activeStage.substage.map((stage, index) => (
                <div key={index} className={styles.timelineItem}>
                  <p className={styles.itemDate}>
                    {formatDate(stage.start_date)} - {formatDate(stage.end_date)}
                  </p>

                  <p className={styles.itemDesc}>{stage.text}</p>
                </div>
              ))}

              <div className={styles.endDate}>
                <p>{formatDate(activeStage.substage[activeStage.substage.length - 1].end_date)}</p>
              </div>
            </div>
          )}
        </div>
      </ContentContainer>
    </div>
  );
};

export default Stage;
